let type = {

  // Projects
  SET_PROJECTS: 'SET PROJECTS'

}

export default type
